module.exports = __webpack_public_path__ + "img/Best of Dreiseen Rot.91e2aad4.jpg";